import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import ShowLoading from '../helperComponent/ShowLoading';
import classImg from '../../assets/class.png';
import AddClassForm from './AddClassForm';
import ClassItem from './ClassItem';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
const ClassPage = () => {
  const [buttonText, setButtonText] = useState('Add Class');
  const [showAddClass, setAddClass] = useState(false);
  const [classes, setClasses] = useState([]);
  const [page, setPage] = useState(1);
  const [next, setNext] = useState(1);
  const [showLoading, setShowLoading] = useState(true);

  let history = useHistory();

  const uname = JSON.parse(localStorage.getItem('uname'));
  const URL = 'https://stucharge.bakersbrisk.com/api/liveclassapi';
  let fetchURL = `https://stucharge.bakersbrisk.com/api/liveclassapi?username=${uname}&page=${page}`;
  const AuthStr = process.env.REACT_APP_AUTH_STR;

  // event click handler
  const onClickHandler = () => {
    setAddClass(!showAddClass);
    setButtonText(buttonText === 'Add Class' ? 'Close' : 'Add Class');
  };

  // fetch classes
  useEffect(() => {
    axios
      .get(fetchURL, { headers: { Authorization: AuthStr } })
      .then((response) => {
        // If request is good...
        if (response.status === 200) {
          if (
            response.data.length > 0 &&
            !response.data[response.data.length - 1].has_next
          )
            setNext(0);
          setClasses(response.data);
          setShowLoading(false);
        } else if (response.status !== 200)
          toast.error('Something went wrong, please refresh');
      })
      .catch((error) => {
        if (error) console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchURL]);

  // add className handler
  const addClass = (classData) => {
    var bodyFormData = new FormData();
    bodyFormData.append('username', uname);
    bodyFormData.append('title', classData.title);
    bodyFormData.append('live_class_url', classData.classUrl);
    bodyFormData.append('date', classData.date);
    bodyFormData.append('start_time', classData.startTime);
    bodyFormData.append('end_time', classData.endTime);
    bodyFormData.append('subject', classData.sub);
    // making post request
    axios
      .post(URL, bodyFormData, {
        headers: { Authorization: AuthStr },
      })
      .then(function (response) {
        if (response.status === 201) toast.success('Class added successfully!');
        history.push('/home');
        history.push('/class');
      })
      .catch((error) => {
        toast.error('Something went wrong, please try again');
      });
  };

  return (
    <main>
      <div className='main_container'>
        <div className='main_title'>
          <img src={classImg} alt='student' width='50' />
          <div className='main_greeting'>
            <h1>Class Details</h1>
            <p>Your scheduled classes are visible here</p>
            {showLoading && <ShowLoading />}
          </div>
        </div>

        <div className='add-notes'>
          <button
            onClick={onClickHandler}
            style={{
              background: showAddClass ? '#ef4f4f' : '#00b5c3',
            }}
          >
            {buttonText}
          </button>
        </div>

        {showAddClass && <AddClassForm addClass={addClass} />}

        {classes.length > 0 ? (
          <>
            <div className='table-container'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Start</th>
                    <th>End </th>
                    <th>Edit </th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  <ClassItem classes={classes} />
                </tbody>
              </table>
            </div>
            <div className='change-page'>
              {page > 1 ? (
                <button
                  type='button'
                  onClick={() => setPage(page > 1 ? page - 1 : 1)}
                >
                  Prev
                </button>
              ) : null}
              {next === 1 ? (
                <button type='button' onClick={() => setPage(page + 1)}>
                  Next
                </button>
              ) : null}
            </div>
          </>
        ) : (
          <div className='alert-heading'>
            <h1>No classes scheduled</h1>
          </div>
        )}
      </div>
    </main>
  );
};

export default ClassPage;
